import { Clock3, CreditCard, Info, Package, Truck } from "lucide-react";
import type { PublicCompany } from "@/types/store";
import styles from "./retail.module.css";

type Props = { company: PublicCompany; attendanceLabel: string };

export default function RetailBenefits({ company, attendanceLabel }: Props) {
  const hasPayment =
    company.accept_pix ||
    company.accept_card_on_delivery ||
    company.accept_cash_on_delivery;
  const items = [
    {
      title: "Entrega para todo o Brasil",
      description: "Consulte o frete pelo CEP",
      Icon: Truck,
    },
    {
      title: hasPayment ? "Formas de pagamento" : "Informações da loja",
      description: hasPayment
        ? "Confira as opções aceitas pela loja"
        : "Conheça os detalhes da empresa",
      Icon: hasPayment ? CreditCard : Info,
    },
    {
      title: "Atendimento",
      description: attendanceLabel || "Consulte as informações da loja",
      Icon: Clock3,
    },
    {
      title: "Catálogo online",
      description: "Explore os produtos da loja",
      Icon: Package,
    },
  ];
  return (
    <section className={styles.benefits} aria-label="Informações comerciais">
      <div className={styles.container}>
        {items.map(({ title, description, Icon }) => (
          <div className={styles.benefit} key={title}>
            <Icon size={30} strokeWidth={1.4} aria-hidden="true" />
            <div>
              <h2>{title}</h2>
              <p>{description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
